import React, { useContext, useEffect, useRef } from 'react';
import { Select } from 'antd';
import Text from 'components/Text/Text';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';
import { IGetRestaurantsShort, IGetRestaurantsShortArgs, EntityStatus } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { WatchFullInfoContext, IWatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';
import { getRestaurantsShortInfo } from 'backend/restaurants';
import style from './RestaurantField.module.scss';

const { Option } = Select;

export const RestaurantField: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch } = useFetchData<IGetRestaurantsShort, IGetRestaurantsShortArgs>(
		watchFullInfo?.customerId ? getRestaurantsShortInfo : null,
		{ customerId: watchFullInfo?.customerId || '' },
	);

	useEffect(() => {
		refetch();
	}, [watchFullInfo]);

	return (
		<div className={style.container} data-test="restaurantLabel">
			<Text translationNameSpace="form" translationKey="restaurantLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				value={watchFullInfo?.restaurantId || '-'}
				loading={loading}
				bordered={false}
				showArrow={false}
				disabled={true}
				listItemHeight={response?.data.restaurants.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				{response?.data.restaurants.length ? (
					<>
						{response.data.restaurants.map((el) => {
							return (
								<Option className={style.listItem} value={el.id} key={el.id}>
									{el.name}
									{el.status === EntityStatus.Archived && <ArchivedLabel />}
								</Option>
							);
						})}
					</>
				) : null}
			</Select>
		</div>
	);
};
